import React, { useEffect, useState } from "react";
import NumberInput from "../../component/NumberInput";

export default function ProgressPaymentManager({ initialPayments = [], onChange }) {
    const [payments, setPayments] = useState(initialPayments);
    const [editIndex, setEditIndex] = useState(null);
    const [editPayment, setEditPayment] = useState(null);
    const [newPayment, setNewPayment] = useState({
        title: "",
        amount: "",
        payment_date: "",
        status: false,
    });

    useEffect(() => {
        setPayments(initialPayments || []);
    }, [initialPayments]);

    const handleAddPayment = () => {
        if (!newPayment.title || !newPayment.amount || !newPayment.payment_date) return;

        const updated = [
            ...payments,
            { ...newPayment, amount: Number(newPayment.amount) },
        ];
        setPayments(updated);
        if (onChange) onChange(updated);
        setNewPayment({ title: "", amount: "", payment_date: "", status: false });
    };

    const removePayment = (index) => {
        const updated = payments.filter((_, i) => i !== index);
        setPayments(updated);
        if (onChange) onChange(updated);
    };

    const handleSaveEdit = (index) => {
        if (!editPayment) return;
        const updated = payments.map((item, i) =>
            i === index
                ? {
                    ...item,
                    ...editPayment,
                    amount: editPayment.amount
                        ? Number(editPayment.amount)
                        : 0,
                }
                : item
        );

        setPayments(updated);
        if (onChange) onChange(updated);
        setEditIndex(null);
        setEditPayment(null);
    };

    return (
        <div>
            <h5>Tiến độ thanh toán</h5>

            {/* Form thêm mới */}
            <div className="row mb-3">
                <div className="col">
                    <label>Nội dung</label>
                    <input
                        type="text"
                        className="form-control height32"
                        placeholder="VD: Thanh toán đợt 1"
                        value={newPayment.title}
                        onChange={(e) =>
                            setNewPayment({ ...newPayment, title: e.target.value })
                        }
                    />
                </div>
                <div className="col">
                    <label>Số tiền</label>
                    <NumberInput
                        value={newPayment.amount}
                        onChange={(val) =>
                            setNewPayment({ ...newPayment, amount: String(val ?? "") })
                        }
                        placeholder="VD: 1.000.000"
                    />
                </div>
                <div className="col">
                    <label>Ngày thanh toán</label>
                    <input
                        type="date"
                        className="form-control height32"
                        value={newPayment.payment_date}
                        onChange={(e) =>
                            setNewPayment({ ...newPayment, payment_date: e.target.value })
                        }
                    />
                </div>
                <div className="col">
                    <label>Trạng thái</label>
                    <select
                        className="form-control height32"
                        value={newPayment.status ? "1" : "0"}
                        onChange={(e) =>
                            setNewPayment({
                                ...newPayment,
                                status: e.target.value === "1",
                            })
                        }
                    >
                        <option value="0">Chưa thanh toán</option>
                        <option value="1">Đã thanh toán</option>
                    </select>
                </div>
                <div className="col-auto">
                    <label className="text-white">Thêm</label>
                    <button
                        className="btn btn-sm btn-primary"
                        onClick={handleAddPayment}
                        type="button"
                    >
                        Thêm
                    </button>
                </div>
            </div>

            {/* Bảng */}
            <div className="table-responsive">
                <table className="table table-bordered table-hover">
                    <thead className="thead-dark">
                        <tr>
                            <th style={{ width: "50px" }}>STT</th>
                            <th>Tiêu đề</th>
                            <th style={{ width: "150px" }}>Số tiền</th>
                            <th style={{ width: "150px" }}>Ngày thanh toán</th>
                            <th style={{ width: "150px" }}>Trạng thái</th>
                            <th style={{ width: "120px" }}>Hành động</th>
                        </tr>
                    </thead>
                    <tbody>
                        {payments.length > 0 ? (
                            payments.map((p, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>
                                        {editIndex === index ? (
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={editPayment.title}
                                                onChange={(e) =>
                                                    setEditPayment({
                                                        ...editPayment,
                                                        title: e.target.value,
                                                    })
                                                }
                                            />
                                        ) : (
                                            p.title
                                        )}
                                    </td>
                                    <td>
                                        {editIndex === index ? (
                                            <NumberInput
                                                value={editPayment.amount}
                                                onChange={(val) =>
                                                    setEditPayment({
                                                        ...editPayment,
                                                        amount: String(val ?? ""),
                                                    })
                                                }
                                            />
                                        ) : (
                                            p.amount.toLocaleString("vi-VN") + " đ"
                                        )}
                                    </td>
                                    <td>
                                        {editIndex === index ? (
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={editPayment.payment_date}
                                                onChange={(e) =>
                                                    setEditPayment({
                                                        ...editPayment,
                                                        payment_date: e.target.value,
                                                    })
                                                }
                                            />
                                        ) : (
                                            p.payment_date
                                        )}
                                    </td>
                                    <td>
                                        {editIndex === index ? (
                                            <select
                                                className="form-control"
                                                value={editPayment.status ? "1" : "0"}
                                                onChange={(e) =>
                                                    setEditPayment({
                                                        ...editPayment,
                                                        status: e.target.value === "1",
                                                    })
                                                }
                                            >
                                                <option value="0">Chưa thanh toán</option>
                                                <option value="1">Đã thanh toán</option>
                                            </select>
                                        ) : (
                                            <button
                                                type="button"
                                                className={`btn btn-sm ${p.status ? "btn-success" : "btn-warning"
                                                    }`}
                                            >
                                                {p.status
                                                    ? "Đã thanh toán"
                                                    : "Chưa thanh toán"}
                                            </button>
                                        )}
                                    </td>
                                    <td>
                                        {editIndex === index ? (
                                            <>
                                                <button
                                                    className="btn btn-sm btn-success me-2"
                                                    type="button"
                                                    onClick={() => handleSaveEdit(index)}
                                                >
                                                    Lưu
                                                </button>
                                                <button
                                                    className="btn btn-sm btn-secondary"
                                                    type="button"
                                                    onClick={() => {
                                                        setEditIndex(null);
                                                        setEditPayment(null);
                                                    }}
                                                >
                                                    Hủy
                                                </button>
                                            </>
                                        ) : (
                                            <>
                                                <button
                                                    className="btn btn-sm btn-primary me-2"
                                                    type="button"
                                                    onClick={() => {
                                                        setEditIndex(index);
                                                        setEditPayment({
                                                            ...p,
                                                            amount: String(p.amount), // ép thành string cho NumberInput
                                                        });
                                                    }}
                                                >
                                                    Sửa
                                                </button>
                                                <button
                                                    className="btn btn-sm btn-danger"
                                                    type="button"
                                                    onClick={() => removePayment(index)}
                                                >
                                                    Xóa
                                                </button>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" className="text-center">
                                    Chưa có tiến độ thanh toán
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
